import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { RenderHTMLSelect, RenderNumberInput } from '../../../component/formInput';

var _ = require("lodash");

class TicketRateModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      employee_options: []
    }
  }

  submit = (values) => {
    const { onHide, ticketObj } = this.props;
    const self = this;
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/ticket/ticket_rate',
      data: {
        ticket_id: ticketObj.id,
        ticket_score: parseInt(values.ticket_score),
        employee_id: values.employee_id
      },
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        toast.success("Đánh giá thành công !");
        onHide();
      }else {
        throw new SubmissionError(response.data.error);
      }
    })
  }

  getITSupportList = () => {
    const { onHide } = this.props;
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/employee/list/IT',
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        const data = _.map(response.data.data, (i) => 
          ({label: `${i.full_name} - ${i.email}`, value: i.id})
        )
        self.setState({
          employee_options: data
        })
      }
    })
  }

  componentDidMount() {
    this.getITSupportList();
  }

  handleHideModal = () => {
    const { onHide, reset } = this.props;
    reset();
    onHide();
  }

  render() {

    const { title, submitting, handleSubmit } = this.props;
    const modalConfig = { enforceFocus: false, backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    const {employee_options} = this.state;
    return (
      <Modal
        bsPrefix = "modal"
        {...modalConfig}
        dialogClassName="modal-open">
        <ToastContainer />
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.submit)}>
            <Modal.Body>
              <Field name="employee_id" placeholder="Chọn nhân viên hỗ trợ..." options={employee_options} component={RenderHTMLSelect}></Field>
              <Field name="ticket_score" placeholder="Nhập số điểm từ 0-4..." component={RenderNumberInput}></Field>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a className="btn" onClick={this.handleHideModal}>Đóng</a>
                <button type="submit" className="btn bg-primary" disabled={submitting}>Lưu</button>
              </div>
            </Modal.Footer>
          </form>
      </Modal>
    )
  }
}
const mapState = (state,props) => ({
  initialValues:{
    ticket_score: props.ticketObj.ticket_score, 
    employee_id: props.ticketObj.employee_id
  }
});

const mapDispatch = dispatch => ({
  updateField: (fieldName, value) =>
    dispatch({
      meta: { form: "TicketRateModal", field: fieldName },
      payload: value,
      type: "@@redux-form/CHANGE"
    }),
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'TicketRateModal',
    destroyOnUnmount: true,
    enableReinitialize: true,
  })(withRouter(TicketRateModal))));
